/*============================================================
   REACT DEPENDENCIES
============================================================*/
import { useState } from "react";

/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { useDispatch, useSelector } from "react-redux";

/*============================================================
  MATERIAL UI
============================================================*/
import { FormControl } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

/*============================================================
  PROPRIETARY - COMPONENTS
============================================================*/
import GridSectionHeader from "../../widgets/GridSectionHeader";
import GridSection from "../../widgets/GridSection";

/*============================================================
  PROPRIETARY - REDUX DATA SLICES
============================================================*/
import { updateApplication } from "../../../states/slcApplication.js";

/*============================================================
  PROPRIETARY - UTILS
============================================================*/
import { createReduxAction } from "../../../utils/modelHelper.js";

export default function SectionApplicants() {
  const app = useSelector((state) => state.app);
  const [numberOfApplicants, setNumberOfApplicants] = useState(app.applicantCount);
  const [numberOfApplicantsError, setNumberOfApplicantsError] = useState("");

  const dispatch = useDispatch();

  function handleChange(e) {
    let type = "";
    let name = "";
    let id = e.target.id.toLowerCase();

    if (id === "") {
      type = e.target.type;
      name = e.target.name;
    }

    //NUMBER OF APPLICANTS
    if (type === "radio" && name === "numberofapplicants") {
      var action = createReduxAction("UPDATE_APP_COUNT", e.target.value);
      dispatch(updateApplication(action));
      setNumberOfApplicants(e.target.value);
      setNumberOfApplicantsError("");

      ///Change User
      if (e.target.value === "ONE") action = createReduxAction("UPDATE_CURR_APPLICANT", "first");
      if (e.target.value === "TWO") action = createReduxAction("UPDATE_CURR_APPLICANT", "second");
      dispatch(updateApplication(action));
    }
  }

  return (
    <>
      <GridSection columnSize={12}>
        <GridSectionHeader sectionName="Application Information" />

        <Typography variant="body1">Number of applicants in this financial Analysis?</Typography>

        <RadioGroup
          id="numberofapplicants"
          name="numberofapplicants"
          value={numberOfApplicants}
          onChange={handleChange}
          sx={{ mx: "100" }}
        >
          <FormControl>
            <Stack direction="row">
              <FormControlLabel id="singleApplicant" value="ONE" control={<Radio />} label="One" />
              <FormControlLabel id="multiApplicant" value="TWO" control={<Radio />} label="Two" />
            </Stack>

            {numberOfApplicantsError && (
              <FormHelperText error={numberOfApplicantsError}>Number of applicant(s) required.</FormHelperText>
            )}
          </FormControl>
        </RadioGroup>
      </GridSection>
    </>
  );
}
